import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import Form from "../../components/common/form/Form";
import {domainSchema} from "../../schema/domainSchema";
import {getFormData} from "../../models/domainModel";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import {fetchDomainById, updateDomain} from "../../store/domain-slice";

const DomainEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();

    const {
        items,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.domain);

    useEffect(() => {
        dispatch(fetchDomainById({id: params.domainId}));
    }, [dispatch, params.domainId]);

    const domain = items.find(item => item.id === params.domainId);

    useEffect(() => {
        if (updateStatus === "success") {
            navigator('../..');
        }
    }, [updateStatus, dispatch, navigator ]);

    const formSubmitHandler = (data) => {
        dispatch(updateDomain({
            id: params.domainId,
            data: data
        }));
    };

    const formCancelHandler = () => {
        navigator("..");
    }

    const schema = domainSchema();
    const initialData = getFormData(domain);
    return (
        <>
            <SubHeader title="Update Customer">
                <Button to={`../../`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={updateStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default DomainEdit;